import React from "react";
import { withTranslation } from "react-i18next";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import SvgIcon from "../../../../parts/SvgIcon";
import { RillContext } from "../../../../rill/RillReact/share/base";

class SelectedMembers extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const {
      athletes,
      toggleAthlete,
      toggleShowUnselectedMemberForMobile,
      theme,
      t,
    } = this.props;

    const DesktopHeader = (
      <header className="force-mobile-hidden">
        <p className="s1">{t("athletes.selectedMembers.membersOfGroup")}</p>
      </header>
    );

    const MobileHeader = (
      <header className="force-only-show-mobile">
        <div>
          <p>{t("athletes.selectedMembers.membersOfGroup")}</p>
          <p className="number-athletes">({athletes.length})</p>
        </div>
        {athletes.length > 0 && (
          <button onClick={toggleShowUnselectedMemberForMobile}>
            <span className="add-member-button clipped">
              {t("athletes.selectedMembers.addMember")}
            </span>
          </button>
        )}
      </header>
    );

    return (
      <div className="members-list">
        {DesktopHeader}
        {MobileHeader}
        {athletes.length > 0 && (
          <ul>
            {athletes.map((elem, index) => {
              return (
                <li
                  key={elem._id || index}
                  onClick={() => toggleAthlete(index)}
                >
                  <img src={getAvatarUrl(elem, true, theme, true)} />
                  <span>{elem.name}</span>
                  <SvgIcon
                    src="/img/new-icons/cross.svg"
                    role="button"
                    data-button-type="text-white"
                    data-icon-only="true"
                  />
                </li>
              );
            })}
          </ul>
        )}
        {athletes.length === 0 && (
          <div className="list-no-members">
            <p>
              <strong>{t("athletes.selectedMembers.noMembers")}</strong>
            </p>
            <p>{t("athletes.selectedMembers.selectMembersHint")}</p>
            <button
              className="only-show-mobile"
              onClick={toggleShowUnselectedMemberForMobile}
            >
              <span className="add-member-button clipped">
                {t("athletes.selectedMembers.addMember")}
              </span>
            </button>
          </div>
        )}
      </div>
    );
  }
}

SelectedMembers.contextType = RillContext;

export default withTranslation("coaching-portal")(SelectedMembers);
